<template lang="pug">
.content-wrap
	topbar
	.content-top
		.con
			highlight
			rtt
			.cat-tab.nbswi
				.swiper.glcat-swiper.nbswi-swiper
					.swiper-wrapper
						.swiper-slide
							.cat(@click="$router.push('/')")
								img(src='/new/img/tab/c-hot.png')
								| hot
						.swiper-slide
							.cat(@click="$router.push('/slot')")
								img(src='/new/img/tab/c-slot.png')
								| slots
						.swiper-slide
							.cat(@click="$router.push('/casino')")
								img(src='/new/img/tab/c-casino.png')
								| live
						.swiper-slide
							.cat(@click="$router.push('/table')")
								img(src='/new/img/tab/c-poker.png')
								| poker
						.swiper-slide
							.cat.aaa
								img(src='/new/img/tab/c-bingo.png')
								| bingo
						.swiper-slide
							.cat(@click="$router.push('/hash')")
								img(src='/new/img/tab/c-hash.png')
								| hash
						template(v-if="isLoggedIn")
							.swiper-slide
								router-link.cat(to="/launchWbet" target="_blank")
									img(src='/new/img/tab/c-sport.png')
									| sports
						template(v-else)
							.swiper-slide
								a.cat(@click="$helpers.openModal('#logModal')")
									img(src='/new/img/tab/c-sport.png')
									| sports
						.swiper-slide
							.cat(@click="$router.push('/fishing')")
								img(src='/new/img/tab/c-fish.png')
								| fishing
				.swiper-button-prev.glcat-swiper-prev
				.swiper-button-next.glcat-swiper-next
			.searchbar
				.fav.pointer(v-if="isLoggedIn" @click="toggleFav")
					i.fa-heart(:class="{'fa-solid fav-red': showFav, 'fa-regular': !showFav}")
				.fav.pointer(v-if="!isLoggedIn" @click="$helpers.openModal('#logModal')")
					i.fa-regular.fa-heart
				input.form-control(type='text' v-model="searchinput" placeholder='Search')
				.s-icon
					i.fa-solid.fa-magnifying-glass
			.glmenu.nbswi.mt-2
				.swiper.glpro-swiper.nbswi-swiper
					.swiper-wrapper
						.swiper-slide(@click="changeProvider(1)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 1 }")
								img(src='/new/img/provider/jili.png' )
						.swiper-slide(@click="changeProvider(0)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 0 }")
								img(src='/new/img/provider/yes-bingo.png')
				.swiper-button-prev.glpro-swiper-prev
				.swiper-button-next.glpro-swiper-next
			favList(v-if="showFav" :searchinput="searchinput")
			jili(v-if="providerSelected === 1 && !showFav" :searchinput="searchinput")
			yesbingo(v-if="providerSelected === 0 && !showFav" :searchinput="searchinput")
			//- social
			footerInfo(:target="'/bingo'")
</template>
<script>
import config from "@/config";
import topbar from '@/views/default/_topBar.vue'
import highlight from '@/component/_highlight.vue'
import rtt from '@/component/_realTimeTrans.vue'
import favList from '@/component/bingo/_favList.vue'
import jili from '@/component/bingo/_jili.vue'
import yesbingo from '@/component/bingo/_yesbingo.vue'
import footerInfo from '@/views/default/_footerArticle.vue'
import social from '@/component/_social.vue'
export default {
	components:{
		topbar,
		highlight,
    rtt,
		favList,
		jili,
		yesbingo,
		footerInfo,
    social,
	},
	data(){
		return{
			feedback: {
				success: true,
				status: ""
			},
			loading:false,
			showMobile: false,
			providerSelected: 1,
			imgUrl: config.imageUrl,
			showSearch: false,
			providerList:[
				"YESBINGO",
				"JILI"
			],
			searchinput:"",
			showFav: false
		}
	},
	computed: {
		isLoggedIn(){
			return this.$store.getters.isLoggedIn
		},
		accountID() {
			return this.$store.getters.accountID
		},
		sessionToken() {
			return this.$store.getters.sessionToken
		},
		getProvider(){
			return this.providerList[this.providerSelected]
		},
	},
	created(){
		// this.getSeo("poker")
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/bingo`);
		// this.checkSize()
		// var vm = this
		// $(window).resize(function () {
		// 	vm.checkSize()
		// });
	},
	// metaInfo(){
	// 	if(this.$store.state.user.seoInfo.meta_title && this.$store.state.user.seoInfo.meta_title === "slot"){
	// 		return{
	// 			title: this.$store.state.user.seoInfo.meta_title,
	// 			meta:[
	// 				{vmid: "og:title",name: 'og:title', content: this.$store.state.user.seoInfo.meta_title},
	// 				{vmid: "description",name: 'description', content: this.$store.state.user.seoInfo.meta_desc},
	// 				{vmid: "og:description",name: 'og:description', content: this.$store.state.user.seoInfo.meta_desc},
	// 				{vmid: "author",name: 'author', content: this.$store.state.user.seoInfo.meta_author},
	// 				{vmid: "canonical",name: 'canonical', content: this.$store.state.user.seoInfo.meta_canonical},
	// 				{vmid: "keywords",name: 'keywords', content: this.$store.state.user.seoInfo.meta_keywords},
	// 				{vmid: "language",name: 'lang', content: this.$store.state.user.seoInfo.meta_lang},
	// 				{vmid: "url",name: 'url', content: this.$store.state.user.seoInfo.meta_url},
	// 				{vmid: "og:url",name: 'og:url', content: this.$store.state.user.seoInfo.meta_url},
	// 			],
	// 			link:[
	// 				{ rel: 'image_src', href: this.imgUrl+ this.$store.state.user.seoInfo.meta_image_url},
	// 			]
	// 		}
	// 	}else{
	// 		return{
	// 			title: this.$store.state.user.homeSeo.meta_title,
	// 			meta:[
	// 				{vmid: "og:title",name: 'og:title', content: this.$store.state.user.homeSeo.meta_title},
	// 				{vmid: "description",name: 'description', content: this.$store.state.user.homeSeo.meta_desc},
	// 				{vmid: "og:description",name: 'og:description', content: this.$store.state.user.homeSeo.meta_desc},
	// 				{vmid: "author",name: 'author', content: this.$store.state.user.homeSeo.meta_author},
	// 				{vmid: "canonical",name: 'canonical', content: this.$store.state.user.homeSeo.meta_canonical},
	// 				{vmid: "keywords",name: 'keywords', content: this.$store.state.user.homeSeo.meta_keywords},
	// 				{vmid: "language",name: 'lang', content: this.$store.state.user.homeSeo.meta_lang},
	// 				{vmid: "url",name: 'url', content: this.$store.state.user.homeSeo.meta_url},
	// 				{vmid: "og:url",name: 'og:url', content: this.$store.state.user.homeSeo.meta_url},
	// 			],
	// 			link:[
	// 				{ rel: 'image_src', href: this.imgUrl+ this.$store.state.user.homeSeo.meta_image_url},
	// 			]
	// 		}
	// 	}
		
		
	// },
	mounted(){
		if ($('.glcat-swiper').length) {
			const gboxSwiper = new Swiper('.glcat-swiper', {
				slidesPerView: 6.5,
				spaceBetween: 4,
				navigation: {
					nextEl: '.glcat-swiper-next',
					prevEl: '.glcat-swiper-prev'
				},
				watchOverflow: true,
				autoplay:false,
				breakpoints: {
					768: {
						slidesPerView: 6.5
					},
					960: {
						slidesPerView: 8
					}
				}
			})
    }
		if ($('.glpro-swiper').length) {
      const gboxSwiper = new Swiper('.glpro-swiper', {
        slidesPerView: 3.5,
        spaceBetween: 4,
        navigation: {
            nextEl: '.glpro-swiper-next',
            prevEl: '.glpro-swiper-prev'
        },
        watchOverflow: true,
        autoplay:false,
        breakpoints: {
            768: {
                slidesPerView: 6.5
            },
            960: {
                slidesPerView: 6.5
            }
        }
      })
		}
	},
	methods:{
		openModal(){
			$("#logModal").modal('show')
		},
		toggleFav(){
			this.showFav = !this.showFav
		},
		toggleSearch(){
			this.showSearch = !this.showSearch
		},
		cancelSearch(){
			this.showSearch = false
			this.searchinput = ""
		},
		getSeo(page){
			let page_name = page
			this.$store
				.dispatch("user/getSeo", {page_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
		changeProvider(option){
			if(option !== this.providerSelected){
				this.providerSelected = option
			}
			this.showFav = false
			// if(option === this.providerSelected){
			// 	return
			// }else{
			// 	this.providerSelected = option
			// }
		},
		checkSize(){
			if ($(window).width() < 681) {
				this.showMobile = true
			}else{
				this.showMobile = false
			}
		},
	}
}
</script>